module.exports = "/static/viewer/generated/images/HEAT Logo for Box - Transparent.png?0af14529fb7343de52636fa9d330a421";